module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/payroll/stepOne/PayrollDetail.html -->\n<td class="title">\n    <strong>\n        '+
((__t=( model.getPayrollItemName() ))==null?'':_.escape(__t))+
'\n        <small>\n            ';
 if (
                model.getPayrollItemType() !== 'unpaid_leave' &&
                model.getPayrollItemType() !== 'overtime' &&
                model.get('additionalInformation')
            ) { 
__p+='\n                ';
 info = model.get('additionalInformation'); 
__p+='\n                (\n                    ';
 last = _.last(_.keys(info)); 
__p+='\n                    ';
 _.each(_.keys(info), function(attr, i) { 
__p+='\n                        '+
((__t=( info[attr] + (attr !== last ? ', ' : '') ))==null?'':_.escape(__t))+
'\n                    ';
 }); 
__p+='\n                )\n            ';
 } 
__p+='\n\n            ';
 if (
                model.isOvertime() &&
                model.get('additionalInformation')
            ) { 
__p+='\n                ';
 info = model.get('additionalInformation'); 
__p+='\n                (\n                    Hourly wage: '+
((__t=( info.hourlyWage ))==null?'':_.escape(__t))+
',\n                    Rate: '+
((__t=( info.overtimeFactor ))==null?'':_.escape(__t))+
'x\n                )\n            ';
 } 
__p+='\n        </small>\n    </strong>\n    ';
 if (model.isAdditional()) { 
__p+='\n        <a href="" class="js-remove-button" tabindex="-1">\n            <i class="fa fa-times"></i>\n        </a>\n    ';
 } 
__p+='\n</td>\n\n';
 if (model.isUnit()) { 
__p+='\n    <td>\n        <span>RM:</span>\n        <input name="rate" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
((__t=( (model.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'"\n            ';
 if (model.isOvertime()) { 
__p+='\n                readonly\n            ';
 } 
__p+='\n            ';
 if (model.isLocked()) { 
__p+='\n                readonly data-toggle="tooltip" data-placement="left"\n                title="To change this value you need to edit the employee\'s\n                    employment details"\n            ';
 } 
__p+='\n            >\n    </td>\n    <td>\n        <span>'+
((__t=( model.isOvertime() ? 'Hours' : 'Units' ))==null?'':_.escape(__t))+
':</span>\n        <input name="unit" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
((__t=( (model.get('unit') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'">\n    </td>\n';
 } else { 
__p+='\n    <td></td>\n    <td></td>\n';
 } 
__p+='\n\n<td>\n    <input name="amount" class="form-control text-right form-control-invisible"\n        type="text" autocomplete="off"\n        value="'+
((__t=( (model.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'"\n        '+
((__t=( (model.isLocked() || model.isUnit()) ? 'readonly' : '' ))==null?'':_.escape(__t))+
'\n        ';
 if (model.isLocked()) { 
__p+='\n            data-toggle="tooltip" data-placement="left"\n\n            ';
 if (model.isUnpaidLeave()) { 
__p+='\n                title="Unpaid leave is calculated automatically. To manually calculate unpaid leave, please turn off the \'Record Unpaid Leave In Payroll\' in Payment Settings."\n            ';
 } else if (model.isUnit()) { 
__p+='\n                title="To change this value, you need to change the amount of units billed by the employee"\n            ';
 } else { 
__p+='\n                title="To change this value, you need to edit the employee\'s employment details"\n            ';
 } 
__p+='\n        ';
 } 
__p+='>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/payroll/stepOne/PayrollDetail.html
// module id = 721
// module chunks = 1